<template>
    <v-card
        outlined
        width="800px"
        class="mx-auto"
        rounded="lg"
        :to="esMovil ? { name: 'detalles', params: { id: indicador.id } } : ''"
    >
        <v-container>
            <v-row class="titulo-indicador rounded-t-lg">
                <v-col cols="12">
                    <v-card-title
                        class="subtitle-1 font-weight-bold"
                        style="word-break: break-word"
                        v-text="indicador.nombre"
                    >
                    </v-card-title>
                    <v-card-subtitle class="mt-1">
                        <p class="dato-indicador text-h4 font-weight-bold ma-0">
                            {{ indicador.valor_indicador | separadores }}
                            <span class="text-subtitle-1 font-weight-bold">
                                {{ indicador.unidad_medida }}</span
                            >
                        </p>
                    </v-card-subtitle>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card-text class="mt-2 mb-6">
                        <p class="texto ma-0">{{ indicador.definicion }}</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-row>
                            <v-chip
                                class="px-2 mx-2 mt-2 font-weight-medium"
                                dark
                                v-for="hashtag in indicador.enlaces_hashtags"
                                :key="hashtag.hashtag"
                                :color="hashtag.color"
                                :to="hashtag.link"
                            >
                                {{ hashtag.hashtag }}
                            </v-chip>
                        </v-row>
                    </v-card-actions>
                </v-col>
            </v-row>
            <v-row v-if="!esMovil" justify="center">
                <v-btn
                    dark
                    depressed
                    :to="indicador.link"
                    class="mt-4 mb-4 boton-detalles text-capitalize font-weight-bold"
                >
                    {{ $t("componentes.indicador-card.ver-detalles") }}
                </v-btn>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import GraficasService from "@services/GraficasService";

export default {
    name: "IndicadorCard",
    props: ["indicador", "listaFiltros"],
    components: {},
    computed: {
        esMovil() {
            return this.$vuetify.breakpoint.smAndDown;
        },
    },
    methods: {
        clickHashtag(filtroHashtags) {
            this.$emit("listaFiltros", filtroHashtags);
        },
    },
    filters: {
        separadores: GraficasService.addSeparadores,
    },
};
</script>

<style scoped>
.v-card__subtitle,
.v-card__text,
.v-card__title {
    padding: 0;
}

.v-chip.v-size--default {
    height: 25px;
    border-radius: 0;
}
</style>
